<template>
    <div id="Products" class="wrapper m0-50">
        <div class="section">
            <div class="div-block-15">
                <div class="content4-headline-wrap">
                    <h6><strong class="bold-text-3">Protective Equipment Categories</strong></h6>
                    <div class="size1-text size1-top-clear">Offer or request support for the following products</div>
                </div>
                <div class="w-dyn-list">
                    <div v-if="products.length > 0" class="collection-list-product w-dyn-items w-row">
                        <div v-for="(product, index) in products" :key="product.iD" class="collection-item-2 w-dyn-item w-col w-col-4">
                            <div v-if="product.material == null && product.productType == 'HAND_SANITIZER'" class="product-category-card">
                                    <div v-on:click="toggleModal(index)" data-w-id="3df562af-f9ab-7da2-d67e-b2461b92e2b3" class="div-block-21">
                                        <img :src="product.imageUrl" :alt="product.description" class="image-12">
                                        <div>
                                            <div>{{product.description}}</div>
                                        </div>
                                        <div class="div-block-19">
                                            <div class="required-quantity-title">Demand:</div>
                                            <div class="text-block-5 critical">{{product.demandCategory}}</div>
                                        </div>
                                        <div class="text-block-9">View Product Specifications</div>
                                    </div>
                                    <router-link class="offer-finished-units w-button"
                                                 v-bind:to="{name:'offerFinishedProduct',
                                                             params: { id:  product.id }
                                                            }">
                                        Offer Finished Units</router-link>
                                    <router-link class="offer-mats w-button" v-bind:to="{name:'offerMaterials',
                                                             params: {productType: product.productType,
                                                             productName: product.description,
                                                             id: product.id }
                                                            }">Offer Input Materials</router-link>
                                    <div class="div-block-22"></div>
                                    <router-link class="secondary-option w-button"
                                                 v-bind:to="{name:'requestFinishedProduct',
                                                             params: { id:  product.id }
                                                            }">
                                        Request Finished Units</router-link>
                                    <router-link class="secondary-option w-button"
                                                 v-bind:to="{name:'requestMaterials',
                                                            params: {productType: product.productType,
                                                            productName: product.description}}">
                                        Request Input Materials</router-link>
                                <modal v-if="isProductModalOpen && productIndex === index" class="modal-wrapper" style="opacity: 1; display: flex;">
                                    <div class="modal-background" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d; opacity: 1;">
                                        <div class="modal-title-container">
                                            <div class="modal-header">{{product.description}}</div>
                                        </div>
                                        <div class="div-block-20">
                                            <div class="rich-text-block-3 w-richtext" v-html="product.productDescriptionHtml"></div>
                                        </div>
                                        <div v-on:click="toggleModal(index)" class="close-modal-button"><img src="../assets/images/close.png" data-w-id="a3015145-4c85-2374-0402-d2aa78858340" alt=""></div>
                                    </div>
                                </modal>
                            </div>
                        </div>
                    </div>
                    <div v-if="products.length == 0" class="no-items-found">
                        <div>No items found.</div>
                    </div>
                </div>
                <ComingSoon />
            </div>
        </div>
    </div>
</template>

<script>
    import {listService} from "../assets/js/services/listService";
    import ComingSoon from "./ComingSoon";

    export default {
        name: 'Products',
        components: {
            ComingSoon
        },
        data () {
            return {
                isProductModalOpen: false,
                productIndex: undefined,
                products: []
            }
        },
        created () {
            let _this = this;
            listService.listProducts()
                .then((response) => {
                    this.success = true;
                    localStorage.setItem('ProductsMaterialsList', JSON.stringify(response.content.content));
                    _this.products = response.content.content;
                })
                .catch(() => {
                    this.fail = true;
                });
        },
        methods: {
            toggleModal: function (index) {
                this.productIndex = index;
                if (this.isProductModalOpen)
                    this.isProductModalOpen = false;
                else
                    this.isProductModalOpen = true;
            }
        }
    }
</script>

<style scoped>


    .collection-list-product {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
</style>
